export default __webpack_public_path__ + "assets/saintkittsandnevis-flag.png";